const logOut = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  // eslint-disable-next-line no-restricted-globals
  location.reload()
}

export default logOut
